import Cookies from 'quasar/src/plugins/Cookies.js';import Dark from 'quasar/src/plugins/Dark.js';import Dialog from 'quasar/src/plugins/Dialog.js';import Loading from 'quasar/src/plugins/Loading.js';import LocalStorage from 'quasar/src/plugins/LocalStorage.js';import Notify from 'quasar/src/plugins/Notify.js';import Platform from 'quasar/src/plugins/Platform.js';
import { api } from 'boot/axios'

const TOKEN_KEY = '_token'
export const COOKIE_NAME = 'XSRF-TOKEN'
const DEFAULT_USER = {
  company: {},
  offices: [],
}

async function promisifiedDialog(dialogOptions) {
  return new Promise((resolve, reject) => {
    Dialog.create(dialogOptions)
      .onOk(successResponse => { resolve(successResponse) })
      .onCancel(() => { reject() })
  })
}

export default {
  namespaced: true,

  state: {
    loggedIn: false,
    token: null,
    user: DEFAULT_USER,
  },

  getters: {
    twoFactorEnabled: ({ user: { two_factor_secret } }) => Boolean(two_factor_secret),
  },

  actions: {
    async init({ dispatch, commit }) {
      try {
        Loading.show()
        Platform.is.capacitor && commit('setToken', LocalStorage.getItem(TOKEN_KEY))
        await dispatch('getUser')
        commit('setLoggedIn', true)
      } catch {
        commit('setLoggedIn', false)
      } finally { Loading.hide() }
    },

    async login({ commit, dispatch }, form) {
      if (Platform.is.capacitor) {
        const { data } = await api.post('token', { ...form, device_name: Platform.userAgent })
        commit('setToken', data)
      } else {
        !Cookies.has(COOKIE_NAME) && await api.get('../sanctum/csrf-cookie')
        const { data: { two_factor } } = await api.post('login', form)
        if (two_factor) {
          const code = await promisifiedDialog({
            title: 'Autenticazione a due fattori',
            cancel: true,
            persistent: true,
            prompt: {
              model: '',
              // mask: '######',
              maxlength: 6,
              isValid: val => val.length === 6,
            },
          })
          await api.post('two-factor-challenge', { code })
        }
      }
      await dispatch('init')
    },

    async logout({ commit }) {
      try {
        Loading.show()
        if (Platform.is.capacitor) {
          await api.delete('token')
          commit('setToken', null)
        } else {
          await api.post('logout')
          Cookies.remove(COOKIE_NAME, {
            path: '/',
            domain: process.env.DOMAIN,
          })
        }
        commit('setUser', DEFAULT_USER)
        commit('setLoggedIn', false)
      } catch (error) {
        Notify.create({ type: 'negative', message: 'Qualcosa è andato storto.' })
        throw error
      } finally { Loading.hide() }
    },

    // async sendMail () {
    //   await api.post('email/verification-notification')
    //   Notify.create({ type: 'positive', message: 'Email Inviata' })
    // },

    async getUser({ commit }) {
      const { data } = await api.get('user')
      commit('setUser', data)
    },

    async enableTwoFactor({ dispatch }) {
      await dispatch('checkIfPasswordIsRequired')
      await api.post('user/two-factor-authentication')
      try {
        const svg = await dispatch('getQrCode')
        const code = await promisifiedDialog({
          title: 'Inquadra il Codice QR',
          message: `<div class="flex justify-center"><div style="padding: 6px 6px 0px 6px;width:fit-content;background-color:white;">${svg}</div></div>`,
          prompt: {
            model: '',
            // mask: '######',
            maxlength: 6,
            isValid: val => val.length === 6,
          },
          html: true,
          dark: Dark.isActive,
          cancel: true,
          ok: 'Conferma',
        })
        await api.post('user/confirmed-two-factor-authentication', { code })
        await dispatch('getUser')
        Notify.create({ type: 'positive', message: 'Autenticazione a due fattori abilitata' })
      } catch (error) {
        error && Notify.create({ type: 'negative', message: 'Codice OTP non valido' })
        await dispatch('disableTwoFactor')
      }
    },

    async disableTwoFactor({ dispatch, commit, state }) {
      await dispatch('checkIfPasswordIsRequired')
      await api.delete('user/two-factor-authentication')
      commit('setUser', { ...state.user, two_factor_secret: false })
    },

    async getQrCode({ dispatch }) {
      await dispatch('checkIfPasswordIsRequired')
      const { data: { svg } } = await api.get('user/two-factor-qr-code')
      return svg
    },

    async generateRecoveryCodes({ dispatch }) {
      await dispatch('checkIfPasswordIsRequired')
      const { data } = await api.get('user/two-factor-recovery-codes')
      const message = `<ul>${data.map(code => `<li>${code}</li>`).join('')}</ul>`
      Dialog.create({
        title: 'Codici di Recupero',
        message,
        html: true,
        ok: 'Chiudi',
      })
    },

    // async updatePassword (_, passwords) {
    //   await api.put('user/password', passwords)
    // },

    // forgotPassword (_, model) {
    //   Dialog.create({
    //     title: 'Recupera Password',
    //     message: 'Inserisci l\'indirizzo email con cui hai effettuato la registrazione',
    //     cancel: true,
    //     persistent: true,
    //     prompt: { model, type: 'email', isValid: val => Boolean(val) }
    //   }).onOk(async email => {
    //     Loading.show()
    //     await api.post('forgot-password', { email })
    //     Loading.hide()
    //     Notify.create({ type: 'positive', message: 'Email Inviata con successo', caption: 'Segui le istruzioni all\'interno della mail per resettare la password' })
    //   })
    // },

    // async resetPassword (_, form) {
    //   await api.post('reset-password', form)
    //   Notify.create({ type: 'positive', message: 'Password aggiornata' })
    // },

    async checkIfPasswordIsRequired() {
      const { data: { confirmed } } = await api.get('user/confirmed-password-status')
      if (!confirmed) {
        const password = await promisifiedDialog({
          title: 'Conferma Password',
          message: 'Per questioni di sicurezza inserisci la password corrente',
          cancel: true,
          persistent: true,
          prompt: { model: '', type: 'password' },
        })
        await api.post('user/confirm-password', { password })
      }
    },
  },

  mutations: {
    setLoggedIn(state, loggedIn) { state.loggedIn = loggedIn },
    setUser(state, user) { state.user = user },
    setToken(state, token) { // capacitor
      state.token = token
      token === null
        ? LocalStorage.remove(TOKEN_KEY)
        : LocalStorage.set(TOKEN_KEY, token)
    },
  },
}
